"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Terms = exports.useDownloadTerms = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Template_1 = require("./Template");
var i18n_1 = require("../i18n");
var tss_react_1 = require("tss-react");
var i18n_2 = require("../i18n");
/** Allow to avoid bundling the terms and download it on demand*/
function useDownloadTerms(params) {
    var kcContext = params.kcContext, downloadTermMarkdown = params.downloadTermMarkdown;
    var _a = __read((0, react_1.useReducer)(function (x) { return x + 1; }, 0), 2), forceUpdate = _a[1];
    (0, react_1.useEffect)(function () {
        var currentKcLanguageTag = (0, i18n_2.getCurrentKcLanguageTag)(kcContext);
        downloadTermMarkdown({ currentKcLanguageTag: currentKcLanguageTag }).then(function (thermMarkdown) {
            i18n_2.kcMessages[currentKcLanguageTag].termsText = thermMarkdown;
            forceUpdate();
        });
    }, []);
}
exports.useDownloadTerms = useDownloadTerms;
exports.Terms = (0, react_1.memo)(function (_a) {
    var kcContext = _a.kcContext, props = __rest(_a, ["kcContext"]);
    var _b = (0, i18n_1.getMsg)(kcContext), msg = _b.msg, msgStr = _b.msgStr;
    var cx = (0, tss_react_1.useCssAndCx)().cx;
    var url = kcContext.url;
    return ((0, jsx_runtime_1.jsx)(Template_1.Template, __assign({}, __assign({ kcContext: kcContext }, props), { doFetchDefaultThemeResources: true, displayMessage: false, headerNode: msg("termsTitle"), formNode: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ id: "kc-terms-text" }, { children: msg("termsText") })), (0, jsx_runtime_1.jsxs)("form", __assign({ className: "form-actions", action: url.loginAction, method: "POST" }, { children: [(0, jsx_runtime_1.jsx)("input", { className: cx(props.kcButtonClass, props.kcButtonClass, props.kcButtonClass, props.kcButtonPrimaryClass, props.kcButtonLargeClass), name: "accept", id: "kc-accept", type: "submit", value: msgStr("doAccept") }), (0, jsx_runtime_1.jsx)("input", { className: cx(props.kcButtonClass, props.kcButtonDefaultClass, props.kcButtonLargeClass), name: "cancel", id: "kc-decline", type: "submit", value: msgStr("doDecline") })] })), (0, jsx_runtime_1.jsx)("div", { className: "clearfix" })] }) })));
});
//# sourceMappingURL=Terms.js.map